
const proxy = {
  run: false,
  url: {
    gateway: {
      default: 'https://gateway-test.wuzheng.com.cn/',
      dev: 'https://gateway-dev.wuzheng.com.cn/',
      test: 'https://gateway-test.wuzheng.com.cn/',
      prod: 'https://gateway.wuzheng.com.cn/'
    }
  },
  data: {},
  buildProp: function(type, prop) {
    return `/${type}_${prop}`
  }
}

if (process.env.NODE_ENV === 'development') {
  proxy.run = true
  // proxy.url.gateway.default = 'http://10.1.160.36:8080/'
  // proxy.url.gateway.test = 'http://10.1.160.36:8080/'
}

if (proxy.run) {
  for (const type in proxy.url) {
    for (const prop in proxy.url[type]) {
      const currentProp = proxy.buildProp(type, prop)
      proxy.data[currentProp] = {
        target: proxy.url[type][prop],
        ws: true,
        changeOrigin: true,
        pathRewrite: {
          ['^' + currentProp]: ''
        }
      }
    }
  }
  // eslint-disable-next-line no-console
  console.warn('开启代理：', proxy.data)
}

module.exports = {
  proxy: proxy
}
